import React from 'react';
import { IconProps } from '../../../../../types/components';

export default function ChevronLeft({ iconClass, width, height }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
      role="img"
      viewBox="0 0 10 17"
      className={iconClass}
      width={width}
      height={height}
    >
      <path d="M0 8.22656L0.597656 7.62891L7.62891 0.597656L8.22656 0L9.38672 1.19531L8.78906 1.79297L2.35547 8.22656L8.78906 14.6602L9.38672 15.2578L8.22656 16.4531L7.62891 15.8555L0.597656 8.82422L0 8.22656Z" />
    </svg>
  );
}
